// Shared site data for Draft & Defend

export const CONTACT = {
  phone: "972-413-8181",
  phoneHref: "tel:9724138181",
  email: "draftanddefend@gmail.com",
  emailHref: "mailto:draftanddefend@gmail.com",
  facebook: "https://www.facebook.com/",
  x: "https://x.com/",
  website: "www.draftanddefend.com",
};

export const LOGO = {
  horizontal:
    "https://static.prod-images.emergentagent.com/jobs/71bef967-5c3d-4c6a-9510-e156be7bb755/images/0fcff1a71d9980e1fef4c6aac0f224ec1edbb080ff08f357d6718b8371a7df19.png",
  stacked:
    "https://static.prod-images.emergentagent.com/jobs/71bef967-5c3d-4c6a-9510-e156be7bb755/images/518ffc537c88964ef4155e9dfe37a3239a5da1f54b26aaa57d48759db89cbf13.png",
};

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1562564055-71e051d33c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBvZmZpY2UlMjBkb2N1bWVudCUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzg0MjY0NjY5fDA&ixlib=rb-4.1.0&q=85",
  eviction:
    "https://images.unsplash.com/photo-1741156386380-0236c72eb6f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxob3VzZSUyMGtleXMlMjBwcm9wZXJ0eSUyMHJlYWwlMjBlc3RhdGV8ZW58MHx8fHwxNzg0MjY0Njg2fDA&ixlib=rb-4.1.0&q=85",
  debt:
    "https://images.unsplash.com/photo-1611125832047-1d7ad1e8e48f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxjYWxjdWxhdG9yJTIwbW9uZXklMjBmaW5hbmNlJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzg0MjY0Njg2fDA&ixlib=rb-4.1.0&q=85",
  traffic:
    "https://images.unsplash.com/photo-1635930919419-f935f8902b0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHx0cmFmZmljJTIwcm9hZCUyMGxhdyUyMGxlZ2FsfGVufDB8fHx8MTc4NDI2NDY2OXww&ixlib=rb-4.1.0&q=85",
  resume:
    "https://images.unsplash.com/photo-1698047681432-006d2449c631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxyZXN1bWUlMjBpbnRlcnZpZXclMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg0MjY0NjY5fDA&ixlib=rb-4.1.0&q=85",
  business:
    "https://images.unsplash.com/photo-1758876020200-1e19cddaf656?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHdyaXRpbmclMjBkZXNrfGVufDB8fHx8MTc4NDI2NDY2OXww&ixlib=rb-4.1.0&q=85",
  aboutDesk:
    "https://images.unsplash.com/photo-1683921070230-9f046e462e46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxkb2N1bWVudHMlMjBwZW4lMjBkZXNrJTIwZmxhdGxheXxlbnwwfHx8fDE3OTAyODkzMDB8MA&ixlib=rb-4.1.0&q=85",
};

export const DISCLOSURE_PARAGRAPHS = [
  "Draft & Defend is a professional document preparation (scrivener) service and a service division of Summers Administrative Group. We are not attorneys and are not licensed to practice law. We do not provide legal advice, legal opinions, or legal strategy, and we do not represent clients in court.",
  "We prepare documents solely at your direction and based exclusively on the information and instructions you provide. You are responsible for deciding what statements, responses, or requested items you want included in your filing. If you request reference materials, we may provide links to public self-help resources or a client-selected checklist drawn from those public sources; we do not select, interpret, or recommend what applies to your situation.",
  "No attorney\u2013client relationship is created by use of this service. All documents are provided for your review and approval prior to filing. You remain solely responsible for deadlines, court requirements, legal decisions, and court filings.",
  "Results are not guaranteed. You are responsible for confirming deadlines and court-specific filing rules.",
];

export const SHORT_DISCLAIMER =
  "Draft & Defend is not a law firm. We are not attorneys and do not provide legal advice.";

// Service categories for the homepage grid
export const CATEGORIES = [
  {
    key: "eviction",
    title: "Eviction",
    icon: "Home",
    image: IMAGES.eviction,
    blurb: "JP Court eviction answers, fee-waiver forms, and appeal packages.",
  },
  {
    key: "traffic",
    title: "Traffic",
    icon: "TrafficCone",
    image: IMAGES.traffic,
    blurb: "Citation motions and client-directed traffic filings.",
  },
  {
    key: "debt",
    title: "Debt Claims",
    icon: "Scale",
    image: IMAGES.debt,
    blurb: "Written answers to debt-collection and small civil matters.",
  },
  {
    key: "resume",
    title: "Resume / LinkedIn",
    icon: "FileUser",
    image: IMAGES.resume,
    blurb: "ATS-optimized resumes and professional LinkedIn branding.",
  },
  {
    key: "business",
    title: "Business Writing",
    icon: "PenLine",
    image: IMAGES.business,
    blurb: "Business plans, correspondence, and administrative consulting.",
  },
];

// Full service catalog with current pricing
export const SERVICE_GROUPS = [
  {
    group: "Core Eviction Services",
    services: [
      {
        id: "jp-eviction-answer",
        title: "JP Court Eviction Answer",
        price: "Starting at $50",
        note: "Introductory Rate",
        description:
          "Document preparation of a tenant's Answer to a JP Court eviction filing using client-provided information and client-selected response items.",
      },
      {
        id: "rule-145-fee-waiver",
        title: "Statement of Inability to Afford Payment (Fee Waiver)",
        price: "Starting at $40",
        description:
          "Preparation of the Texas Rule 145 form based on client-provided financial information.",
      },
      {
        id: "eviction-appeal-package",
        title: "Eviction Appeal Package",
        price: "Starting at $150",
        description:
          "Includes preparation of a Notice of Appeal and Rule 145 form for filing per court requirements.",
      },
    ],
  },
  {
    group: "Specialty Motions & Traffic",
    services: [
      {
        id: "motion-appear-remotely",
        title: "Motion to Appear Remotely / Waiver of Presence",
        price: "Starting at $50",
        description:
          "Preparation of a client-directed filing request using stated reasons and information.",
      },
      {
        id: "traffic-citation-motion",
        title: "Traffic Citation Motion (General)",
        price: "Starting at $60",
        description:
          "Preparation/formatting of client-directed motions or requests related to a citation, based on client statements.",
      },
      {
        id: "debt-claim-answer",
        title: "Debt Claim Answer",
        price: "Starting at $75",
        description:
          "Document preparation of a written Answer to a debt-collection case, including a General Denial and any additional client-directed statements.",
      },
    ],
  },
  {
    group: "Administrative Services",
    services: [
      {
        id: "professional-demand-letter",
        title: "Professional Demand Letter",
        price: "$50",
        description:
          "A firm, professional letter prepared at the client's direction, for the client to sign and send, to help resolve a dispute before it goes to court.",
      },
      {
        id: "business-writing-consulting",
        title: "Business Writing & Administrative Consulting (Non-Legal Services)",
        price: "$65/hour",
        description:
          "Business plan drafting/structuring, professional correspondence and document editing, administrative workflow organization, strategic document review for clarity and formatting.",
      },
      {
        id: "ats-resume",
        title: "ATS-Optimized Resume",
        price: "$50",
        paypalLink: "https://www.paypal.com/ncp/payment/UB8H524YFSBE2",
        description:
          "Professional formatting and keyword optimization for Applicant Tracking Systems.",
      },
      {
        id: "resume-linkedin-branding",
        title: "Resume + LinkedIn Package",
        price: "$75",
        description:
          "Includes resume rewriting/formatting, LinkedIn optimization, achievement-focused content, ATS keyword optimization, and personalized recommendations.",
      },
    ],
  },
  {
    group: "Writing & Business Services",
    services: [
      {
        id: "professional-letter-writing",
        title: "Professional Letter Writing",
        price: "$35",
        paypalLink: "https://www.paypal.com/ncp/payment/DV876T9KMTDRA",
        description:
          "Professional letter prepared at the client's direction for the client to sign and send.",
      },
      {
        id: "promotional-content",
        title: "Promotional Content & Business Writing",
        price: "$50",
        description: "Promotional and business content writing.",
      },
      {
        id: "business-research-strategy",
        title: "Business Research & Strategy",
        price: "$75",
        description: "Business research and strategic document support.",
      },
    ],
  },
];

// Detailed client-facing explanations for eviction / traffic / debt
export const DETAILED_DESCRIPTIONS = [
  {
    title: "Texas Eviction Response (JP Court)",
    body: "Document preparation (typing and formatting) of a tenant's written Answer to a Texas JP Court eviction petition, based solely on client instructions. Client provides the facts; Draft & Defend types and formats the response. If requested, a client-selected checklist of commonly raised response items (drawn from public self-help resources) can be provided \u2014 the client chooses what's included. Draft & Defend does not choose, interpret, apply, or advise on legal theories.",
    disclosure: "No legal advice is provided. All decisions remain with the client.",
  },
  {
    title: "Traffic Notices & Filings",
    body: "Document preparation for requests/notices related to traffic matters, based solely on client instructions. Client is responsible for confirming court-specific rules, deadlines, and filing procedures.",
    disclosure: "No legal advice is provided. All decisions remain with the client.",
  },
  {
    title: "Debt Claim & Civil Answers",
    body: "Document preparation for self-represented individuals responding to debt claims or small civil matters. Client decides what to admit, deny, or state; Draft & Defend acts as a professional scrivener to keep the document organized.",
    disclosure: "No legal advice is provided. All decisions remain with the client.",
  },
];
